import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

const EMPTY_PENDING_FORM = {
  accountName: '',
  companyName: '',
  country: null,
  firstName: '',
  lastName: '',
}

export const useOnboardingStore = defineStore('account-onboarding', () => {
  const isTermsStep = ref(false)
  const flowType = ref(null)
  const pendingForm = ref({ ...EMPTY_PENDING_FORM })

  function saveWelcomeAndAdvanceToTerms({
    flowType: nextFlowType,
    accountName,
    companyName,
    country,
    firstName,
    lastName,
  }) {
    flowType.value = nextFlowType
    pendingForm.value = {
      accountName: accountName ?? '',
      companyName: companyName ?? '',
      country: country ?? null,
      firstName: firstName ?? '',
      lastName: lastName ?? '',
    }
    isTermsStep.value = true
  }

  function resetState() {
    isTermsStep.value = false
    flowType.value = null
    pendingForm.value = { ...EMPTY_PENDING_FORM }
  }

  return {
    isTermsStep,
    flowType,
    pendingForm,
    saveWelcomeAndAdvanceToTerms,
    resetState,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOnboardingStore, import.meta.hot))
}
